"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
exports.PropertiesPaper = function () { return (React.createElement(common_1.PropertyTable, null,
    React.createElement(common_1.Property, { name: "elevation", type: "number", defaultValue: "1", description: "Elevation level. Can be one of: [0,1,2,3]." }))); };
exports.PropertiesPaper.displayName = 'PropertiesPaper';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentPaperPage/PropertiesPaper.tsx
// module id = 696
// module chunks = 0